/* tslint:disable */

declare var Object: any;
export interface TtarondutypurposecompInterface {
  "purposeCode": string;
  "itemCode": string;
  "companyId": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  ttamondutyallowitems?: any[];
}

export class Ttarondutypurposecomp implements TtarondutypurposecompInterface {
  "purposeCode": string;
  "itemCode": string;
  "companyId": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  ttamondutyallowitems: any[];
  constructor(data?: TtarondutypurposecompInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttarondutypurposecomp`.
   */
  public static getModelName() {
    return "Ttarondutypurposecomp";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttarondutypurposecomp for dynamic purposes.
  **/
  public static factory(data: TtarondutypurposecompInterface): Ttarondutypurposecomp{
    return new Ttarondutypurposecomp(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttarondutypurposecomp',
      plural: 'Ttarondutypurposecomps',
      path: 'Ttarondutypurposecomps',
      properties: {
        "purposeCode": {
          name: 'purposeCode',
          type: 'string'
        },
        "itemCode": {
          name: 'itemCode',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
      },
      relations: {
        ttamondutyallowitems: {
          name: 'ttamondutyallowitems',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttarondutypurposecomp.ts